//存储json到缓存
export function getCache(TokenKey) {
  return JSON.parse(localStorage.getItem(TokenKey))
}

export function setCache(TokenKey, token) {
  return localStorage.setItem(TokenKey, JSON.stringify(token))
}

export function removeCache(TokenKey) {
  return localStorage.removeItem(TokenKey)
}
